"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compare = exports.createCompareWithComparator = void 0;
const Result_1 = require("./Result");
const Comparable_1 = require("./Comparable");
const Equal_1 = require("./Equal");
const Less_1 = require("./Less");
const Greater_1 = require("./Greater");
function createCompareWithComparator(comparator) {
    const func = (a, b) => {
        return compare(a, b, comparator);
    };
    func.reverse = (a, b) => {
        return func(a, b).reverse;
    };
    return func;
}
exports.createCompareWithComparator = createCompareWithComparator;
function compare(a, b, comparator) {
    if (comparator) {
        const result = comparator(a, b);
        return Result_1.Result.is(result) ? result : Result_1.Result.fromSortResult(result);
    }
    if (Comparable_1.Comparable.is(a) && Comparable_1.Comparable.is(b)) {
        return a.compare(b);
    }
    // eslint-disable-next-line eqeqeq
    if (a == b) {
        return Equal_1.Equal;
    }
    else if (a < b) {
        return Less_1.Less;
    }
    return Greater_1.Greater;
}
exports.compare = compare;
compare.reverse = function (a, b, comparator) {
    return compare(a, b, comparator).reverse;
};
